import * as Sentry from '@sentry/react'

/**
 * Initialize Sentry for error tracking and performance monitoring
 * Only initializes if VITE_SENTRY_DSN environment variable is set
 */
export function initSentry() {
  const sentryDsn = import.meta.env.VITE_SENTRY_DSN
  const environment = import.meta.env.MODE || 'development'
  
  // Only initialize Sentry if DSN is provided
  if (!sentryDsn) {
    console.info('Sentry DSN not configured - error tracking disabled')
    return
  }

  Sentry.init({
    dsn: sentryDsn,
    environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    
    // Performance Monitoring
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0, // 10% in production, 100% in dev
    
    // Session Replay (optional - can be enabled later)
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    
    // Ignore certain errors
    ignoreErrors: [
      // Browser extensions
      'top.GLOBALS',
      // Random network errors
      'NetworkError',
      'Network request failed',
    ],
  })
}

// Re-export commonly used Sentry methods
export { Sentry }
